import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Card from "../../components/card/Card";
import "./TourPage.css";
import { useLocation } from "react-router-dom";

const TourPage = () => {
  const [filters, setFilters] = useState({
    location: "",
    priceRange: null,
    typeOfTour: "",
    packageFilter: "",
    hotel: "",
  });

  const handleFilterChange = (filterValues) => {
    setFilters(filterValues);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageFilterFromUrl = queryParams.get("package");

  useEffect(() => {
    if (packageFilterFromUrl) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        packageFilter: packageFilterFromUrl,
      }));
    }
  }, [packageFilterFromUrl]);

  return (
    <div className="app-container">
      <Sidebar onFilterChange={handleFilterChange} />
      <div className="main-content">
        <Card filters={filters} setFilters={setFilters} />
      </div>
    </div>
  );
};

export default TourPage;
